import React from "react"
import RestartBtn from "../btn/RestartBtn"
import SendBtn from "../btn/SendBtn"
import { WinnerTitle } from "../WinnerTitle"
import {FetchLeaderBoard} from "../leaderboard/FetchLeaderBoard"
import {User} from "../utils"
import "./modal.css"



export default class Modal extends React.Component{
  constructor(props) {
    super() 
    this.state = {
      close: false,
      name: "",
      btnDisabled: true
    }

    this.handleClickClose = this.handleClickClose.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleClickClose() {
    this.setState({
      close: true
    })
  }

  handleSubmit(e) {
    if (e) {
      e.preventDefault()
    }

    if (this.state.name.length < 3 || this.state.name.length > 10) {
      return
    }

    this.handleClickClose()


    FetchLeaderBoard.addRecord(new User({...this.state, ...this.props}))
    
  }

  handleChange(e) {
    if (e.target.value.length < 3 || e.target.value.length > 10) {
      this.setState({
        btnDisabled: true
      })
    } else {
      this.setState({
        btnDisabled: false,
        name: e.target.value
      })
    }
  }

  render() {
    return this.state.close 
    ? ""
    : (
      <div className="modal-wrapper">
        <div className="modal">
          <span className="modal__close" onClick={this.handleClickClose}>&times;</span>
          <WinnerTitle/>
          <div className="modal-info">
            <h3>Your clicks: {this.props.clicks} </h3>
            <ModalInfo handleSubmit={this.handleSubmit} handleChange={this.handleChange} btnDisabled={this.state.btnDisabled}/>
          </div>
          <RestartBtn inner="Restart" handleClick={this.props.handleClickRestart}/>
        </div>
      </div>
    ) 
  }
}


function ModalInfo(props) {
  return (
    <form className="modal-form" onSubmit={props.handleSubmit}>
      <label htmlFor="modal-input">
        <h4>Please, write your name for saving clicks in the Leaderboard (3-10 letters)</h4>
      </label>
      <div className="modal-inputs">
        <input type="text" className="modal-input" id="modal-input" onChange={props.handleChange}/>
        <SendBtn inner="Send" disabled={props.btnDisabled} handleClick={props.handleSubmit}/>
        {/* <button className="modal-submit" disabled={props.btnDisabled}>Send</button> */}
      </div>
    </form>
  )
}